export const TOGGLE_DEBUGGER = 'TOGGLE_DEBUGGER';
export const TOGGLE_FULLBUTTON = 'TOGGLE_FULLBUTTON';
export const TOGGLE_CLOSEBUTTON = 'TOGGLE_CLOSEBUTTON';

export const clickDebuggerButton = () => (dispatch, getState) => {
  const {chatRoot} = getState();

  chatRoot.debugFunc();

  return dispatch({
    type: TOGGLE_DEBUGGER
  });
};

export const clickFullButton = () => (dispatch, getState) => {
  const {chatRoot} = getState();

  chatRoot.fullFunc();

  return dispatch({
    type: TOGGLE_FULLBUTTON
  });
};

export const clickCloseButton = () => (dispatch, getState) => {
  const {chatRoot} = getState();

  chatRoot.closeFunc();

  return dispatch({
    type: TOGGLE_CLOSEBUTTON
  });
};



// WEBPACK FOOTER //
// ./src/actions/chat-header/index.js